'use client'

import * as React from 'react'
import { useConsent } from '@/lib/consent'

export function CookiePreferencesLink({ className }: { className?: string }) {
  const { openSettings } = useConsent()
  return (
    <button
      type="button"
      onClick={openSettings}
      className={className ?? 'hover:text-foreground'}
    >
      Cookie preferences
    </button>
  )
}
